import React from "react";
import PricingSection from "../components/PricingSection";
import { FAQSection, FinalCTA } from "../components/HomeSections";

const PricingPage = () => (
  <main className="bg-[#FFF7F0] min-h-[calc(100vh-72px)]">
    <div className="pt-16 pb-8">
      <PricingSection compact />
    </div>
    <div className="bg-white">
      <FAQSection />
    </div>
    <FinalCTA />
  </main>
);

export default PricingPage;
